import {
  AccountCircle as AccountCircleIcon,
  Help as HelpIcon,
  KeyboardArrowDown as KeyboardArrowDownIcon,
  Logout as LogoutIcon,
  ManageAccounts as ManageAccountsIcon,
  Notifications as NotificationsIcon,
  Search as SearchIcon,
  Settings as SettingsIcon,
} from "@mui/icons-material";
import { Box, Divider, InputAdornment, InputBase, Paper } from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import watermark from "../../assets/watermark.png";
import headerLogo from "../../assets/headerLogo.png";
import { Link } from "react-router-dom";
import { useAuthContext } from "../../context/AuthProvider";
import { useLocation, useNavigate } from "react-router-dom";

const containerStyle = {
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  padding: "4px 20px",
  minHeight: "50px",
  borderBottom: "1px solid rgba(159, 159, 159, 0.2)",
  backgroundColor: "white",
};
const divStyle = { textAlign: "center" };
// const searchIconStyle = {
//   color: "#9F9F9F",
//   ml: "3px",
//   mr: "-3px",
//   width: "20px",
//   height: "20px",
// };
// const inputStyle = {
//   borderRadius: "20px",
//   width: "60%",
//   height: "36px",
//   border: "1px solid #9F9F9F",
// };
const iconStyle = {
  "&:hover": { color: "#FD5707" },
  cursor: "pointer",
  color: "#404040",
};
const keyboardArrowIconStyle = {
  width: "20px",
  height: "20px",
  ml: "-1px",
  mb: "2px",
};
const boxStyle = {
  fontSize: "15px",
  p: 1,
  "&:hover": { backgroundColor: "rgba(253, 87, 7, 0.1)" },
  cursor: "pointer",
  color: "#404040",
};
const paperStyle = {
  position: "absolute",
  top: 50,
  right: 20,
  width: "150px",
  display: "flex",
  flexDirection: "column",
  zIndex: 999,
  backgroundColor: "white",
  margin: "auto",
  padding: "4px 12px",
  justifyContent: "space-between",
  boxShadow: "0px 3px 6px #0000001F",
};
const iconStyle2 = {
  mb: -0.5,
  width: "20px",
  height: "20px",
  color: "#404040",
};

function Header() {
  const [greeting, setGreeting] = useState("");
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const getCurrentHour = () => {
      return new Date().getHours();
    };
    const setGreetingBasedOnTime = () => {
      const currentHour = getCurrentHour();
      if (currentHour < 12) {
        setGreeting("Good Morning!");
      } else if (currentHour < 18) {
        setGreeting("Good Afternoon!");
      } else {
        setGreeting("Good Evening!");
      }
    };
    setGreetingBasedOnTime();
    const intervalId = setInterval(setGreetingBasedOnTime, 60000);
    return () => clearInterval(intervalId);
  }, []);
  const [isDropdownVisible, setDropdownVisible] = useState(false);
  const { logout, authState } = useAuthContext();

  const handleBoxClick = () => {
    setDropdownVisible(!isDropdownVisible);
  };

  const handleLogout = () => {
    logout();
  };

  const paperRef = useRef(null);
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (paperRef.current && !paperRef.current.contains(event.target)) {
        setDropdownVisible(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const isOnSettingsPage = location.pathname === "/settings";
  const handleSettingsClick = () => {
    navigate("/settings");
  };
  const onRefinaryClick = () => {
    navigate("/plant");
  };

  return (
    <>
      <div style={containerStyle}>
        <div
          style={{
            ...divStyle,
            // flex: 1.5,
            display: "flex",
            // justifyContent: "flex-start",
            alignItems: "center",
            gap: "6px",
            cursor: "pointer",
          }}
        >
          <img src={watermark} alt="header" width="20px" height="20px" />
          <Divider
            sx={{ backgroundColor: "#868686", height: "22px", width: "2px" }}
            orientation="vertical"
            variant="middle"
            flexItem
          />
          <img src={headerLogo} alt="header" height="20px" width="120px" />
        </div>
        {/* <div style={{ ...divStyle, flex: 2.5 }}>
          <InputBase
            type="text"
            placeholder="Search..."
            startAdornment={
              <InputAdornment position="start">
                <SearchIcon sx={searchIconStyle} />
              </InputAdornment>
            }
            sx={inputStyle}
          />
        </div> */}
        <div
          style={{
            fontWeight: 500,
            color: "#444444",
            cursor: "pointer",
            textDecoration: "underline",
          }}
          onClick={onRefinaryClick}
        >
          {authState?.selectedRefinary}
          {/* IAC COTTONDALE */}
        </div>
        <div
          style={{
            ...divStyle,
            // flex: 1,
            display: "flex",
            // justifyContent: "flex-end",
            alignItems: "center",
            gap: "15px",
          }}
        >
          <Box sx={{ fontWeight: 500, color: "#444444" }}>{greeting}</Box>
          {/* <Link
            to={isOnSettingsPage ? "#" : "/settings"}
            style={{ textDecoration: "none" }}
          >
            <SettingsIcon
              sx={{
                ...iconStyle,
                color: isOnSettingsPage ? "#EA8600" : "#404040",
              }}
              onClick={handleSettingsClick}
            />
          </Link> */}
          <Box sx={iconStyle} onClick={handleBoxClick}>
            <AccountCircleIcon />
            <KeyboardArrowDownIcon sx={keyboardArrowIconStyle} />
          </Box>
        </div>
      </div>
      {isDropdownVisible && (
        <Paper ref={paperRef} sx={paperStyle}>
          <Box sx={boxStyle} onClick={handleLogout}>
            <LogoutIcon sx={iconStyle2} /> Sign Out
          </Box>
        </Paper>
      )}
    </>
  );
}

export default Header;
